/**
 * Resolves a Lucide icon name string (as stored in the DB) to the actual
 * React component. Used for dynamically created apps whose icon is stored
 * as a string (e.g. 'Brain', 'Globe') rather than as a static import.
 */

import {
  AppWindow, Settings, Shield, FileText, Music, Play, StickyNote, Monitor,
  HardDrive, BotMessageSquare, BrainCircuit, Brain, Library, BookOpen,
  Microscope, GraduationCap, File, Folder, Image, Video, Camera, Mail,
  Calendar, Clock, Calculator, Terminal, Code, Database, Globe, Search,
  MessageSquare, Users, User, Heart, Star, Bookmark, Tag, Bell, Lock,
  Key, Zap, Sparkles, FileEdit, Presentation,
  type LucideIcon,
} from 'lucide-react'

const ICON_MAP: Record<string, LucideIcon> = {
  AppWindow, Settings, Shield, FileText, Music, Play, StickyNote, Monitor,
  HardDrive, BotMessageSquare, BrainCircuit, Brain, Library, BookOpen,
  Microscope, GraduationCap, File, Folder, Image, Video, Camera, Mail,
  Calendar, Clock, Calculator, Terminal, Code, Database, Globe, Search,
  MessageSquare, Users, User, Heart, Star, Bookmark, Tag, Bell, Lock,
  Key, Zap, Sparkles, FileEdit, Presentation,
}

/** Returns the Lucide icon component for the given name, or Globe as fallback. */
export function resolveIcon(name?: string | null): LucideIcon {
  return (name && ICON_MAP[name]) ? ICON_MAP[name] : Globe
}
